export interface StockFactsDto {
  packagingQuantity?: number | null;
  packagingUnitId?: string | null;
  packagingUnitLabel?: string | null;
  remainingContent?: number | null;
  packagingLocked?: boolean;
}

export interface StockFacts {
  packagingQuantity: number | null;
  packagingUnitId: string | null;
  packagingUnitLabel: string | null;
  remainingContent: number | null;
  packagingLocked: boolean;
}

export function mapStockFacts(dto: StockFactsDto): StockFacts {
  return {
    packagingQuantity: dto.packagingQuantity ?? null,
    packagingUnitId: dto.packagingUnitId ?? null,
    packagingUnitLabel: dto.packagingUnitLabel ?? null,
    remainingContent: dto.remainingContent ?? null,
    packagingLocked: dto.packagingLocked === true,
  };
}

export function stockPercent(available: number | null | undefined, capacity: number | null | undefined): number | null {
  if (available == null || capacity == null || !Number.isFinite(available) || !Number.isFinite(capacity)
    || available < 0 || capacity < 0) return null;
  if (capacity === 0) return available === 0 ? 0 : null;
  return Math.min(100, available / capacity * 100);
}
